import { render, staticRenderFns } from "./cuponManage.vue?vue&type=template&id=123d52d0&scoped=true"
import script from "./cuponManage.vue?vue&type=script&lang=js"
export * from "./cuponManage.vue?vue&type=script&lang=js"
import style0 from "./cuponManage.vue?vue&type=style&index=0&id=123d52d0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d52d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('123d52d0')) {
      api.createRecord('123d52d0', component.options)
    } else {
      api.reload('123d52d0', component.options)
    }
    module.hot.accept("./cuponManage.vue?vue&type=template&id=123d52d0&scoped=true", function () {
      api.rerender('123d52d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/cuponManage.vue"
export default component.exports